<!-- task-card.component.html -->
<a (click)="click.emit($event)" [routerLink]="dmdDetailsLink">
	<div class="card tasks-box mb-2">
		<div class="card-body">
			<div class="d-flex mb-3">
				<a href="javascript:void(0)" class="text-muted fw-medium fs-14 flex-grow-1">{{ dmdNumero }}</a>

				@switch (priority) {
					@case ("Urgent") {
						<i class="las la-angle-double-up align-middle me-1 text-danger"></i>
					}
					@case ("Haute") {
						<i class="las la-angle-up align-middle me-1 text-danger"></i>
					}
					@case ("Moyenne") {
						<i class="las la-equals align-middle me-1 text-warning"></i>
					}
					@case ("Faible") {
						<i class="las la-angle-down align-middle me-1 text-info"></i>
					}
				}
			</div>
			<div class="d-flex align-items-center mb-2">
				<app-profile-avatar [image]="demandeur?.avatar?.url" [nom]="demandeur?.nom"></app-profile-avatar>
			</div>
			<h6 class="fs-15 text-truncate task-title mb-0">
				<a [routerLink]="dmdDetailsLink" class="d-block text-truncate">{{ dmdTitle }}</a>
			</h6>
		</div>
		<div class="card-footer border-top-dashed">
			<div class="d-flex">
				<div class="flex-grow-1">
					<span class="text-muted"><i class="ri-time-line align-bottom"></i> {{ dmdDate }}</span>
				</div>
				<div class="flex-shrink-0">
					<ul class="link-inline mb-0 p-0">
						<li class="list-inline-item">
							<a href="javascript:void(0)" class="text-muted"><i class="ri-shopping-basket-line align-bottom"></i> {{ articlesCount }}</a>
						</li>
						<li class="list-inline-item">
							<a href="javascript:void(0)" class="text-muted"><i class="ri-question-answer-line align-bottom"></i> {{ commentsCount }}</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</a>
